<script>
import Questions from "@/components/Quiz/Questions.vue"; // @ is an alias to /src

export default {
  name: "QuizContent",
  components: {
    Questions,
  },
  computed: {
    stepCurrent() {
      return this.$store.getters.step || 0;
    },
    stepTotal() {
      return this.$store.getters.questions.length || 0;
    },
    loadingBarWidth() {
      let res = (this.stepCurrent / this.stepTotal) * 100;

      // Verifica se o valor é infinito
      return isFinite(res) ? res : 0;
    },
    loadingBarWidthString() {
      return this.loadingBarWidth + "%";
    },
    stepCurrentString() {
      if (this.stepCurrent < 10) {
        return "0" + this.stepCurrent;
      } else {
        return this.stepCurrent;
      }
    },
    answerActual() {
      return this.$store.getters.answersActual;
    },
    hasAnswer() {
      return this.answerActual
        ? this.answerActual.answer
          ? true
          : false
        : false;
    },
    btnTextNext() {
      if (this.$store.getters.isLastStep) {
        return "VIEW RESULT";
      } else {
        return "NEXT";
      }
    },
  },
  methods: {
    prevStep() {
      this.$store.dispatch("prevStep");
      window.scrollTo(0, 0);
    },
    nextStep() {
      this.$store.dispatch("nextStep");
      window.scrollTo(0, 0);
    },
  },
  created() {
    if (typeof this.$store.getters.currentUser.email == "undefined") {
      window.location.href = "/dxi";
    }
  },
};
</script>
<template>
  <div id="QuizContent" :class="{ inverse: stepCurrent % 2 }">
    <!-- Logo -->
    <div class="logo-meta">
      <a href="https://metait.ca/dxi/">
        <img src="@/assets/img/logo-meta.png" alt="Logo" class="desk" />
        <img
          width="125"
          height="46"
          src="@/assets/img/logo_white.png"
          alt="Logo"
          class="mob"
        />
      </a>
    </div>

    <div class="mob meta-logo-mob">
      <img src="@/assets/img/questions-logo-mobile.png" class="mob" />
    </div>

    <!-- loading bar % with step -->
    <div class="loading-content">
      <div class="loading-bar">
        <!-- indicador de progreso -->
        <div class="loading-bar-step" :style="{ width: loadingBarWidthString }">
          <div class="loading-bar-indicator">
            {{ loadingBarWidth.toFixed(0) }}%
          </div>
        </div>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          :class="{ active: stepTotal == stepCurrent }"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
    </div>

    <!-- Quiz -->
    <div class="wrapper-content">
      <Questions />
    </div>

    <div class="quiz-a">
      <img src="@/assets/img/quiz-a.png" alt="Quiz A" />
    </div>

    <div class="quiz-footer">
      <!-- exibe o step atual / total de steps -->
      <div class="quiz-footer-meta">
        <img src="@/assets/img/quiz-b.png" alt="" class="quiz-b" />

        <span class="quiz-footer-meta-step">
          <span class="quiz-footer-meta-step-current">{{
            stepCurrentString
          }}</span>
          <span class="quiz-footer-meta-step-separator">/</span>
          <span class="quiz-footer-meta-step-total">{{ stepTotal }}</span>
        </span>
      </div>

      <!-- Botões para controlar o step -->
      <div class="controls desk">
        <button class="button-28 hover-orange" role="button" @click="prevStep">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 reverse"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
          PREVIOUS
        </button>
        <button
          class="button-28 hover-orange"
          role="button"
          @click="nextStep"
          :disabled="!hasAnswer"
        >
          {{ btnTextNext }}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </div>
    </div>

    <div class="mob quiz-footer-mob">
      <div class="controls">
        <button
          class="button-28 hover-orange"
          role="button"
          @click="nextStep"
          :disabled="!hasAnswer"
        >
          {{ btnTextNext }}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
        <button class="button-28 hover-orange" role="button" @click="prevStep">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 reverse"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
          PREVIOUS
        </button>
      </div>
    </div>
    <div class="mob mob-footer-img">
      <img src="@/assets/img/mob-dxi-question-footer.png" />
    </div>
  </div>
</template>
